import { API_URL } from '@/config';
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${API_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const processAuth = async () => {
      const hash = location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }

      try {
        const response = await axios.get(
          `${API}/auth/callback/google`,
          {
            headers: { 'X-Session-ID': sessionId }
          }
        );

        // Store token and user in localStorage
        localStorage.setItem('session_token', response.data.session_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        sessionStorage.setItem('just_authenticated', 'true');
        navigate('/app', { replace: true, state: { user: response.data.user } });
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Authentication failed');
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Authenticating...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
